import type { ReactNode } from 'react'

// Generic (non-honesty) chip: facet tags, benefit-family labels, status marks.
// The honesty badges are a separate, deliberately distinct family — do NOT use
// this for law/design/divergence (that would blur the two-truths surface).

type ChipVariant = 'soft' | 'accent' | 'outline'

interface ChipProps {
  children: ReactNode
  variant?: ChipVariant
  className?: string
}

const variants: Record<ChipVariant, string> = {
  soft: 'bg-accent-soft text-ink',
  accent: 'bg-accent text-paper',
  outline: 'border border-hairline text-muted',
}

export function Chip({ children, variant = 'soft', className = '' }: ChipProps) {
  return (
    <span
      className={`inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-medium leading-none ${variants[variant]} ${className}`}
    >
      {children}
    </span>
  )
}
